import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

// Notification
import useNotifications from "@notifications"

export default function useResponsibleAreasList() {

    // Use toast
	const { toastNotification } = useNotifications()

    const refResponsibleAreasListTable = ref(null);

	const styleColumns = {
        thClass: 'text-center',
        tdClass: 'text-center'
    }

    // Table Handlers
    let tableColumns = [
        { key: 'department_name', sortable: true, label: 'ÁREA <br/> RESPONSABLE', ...styleColumns },
		{ key: 'indicator_name', sortable: true, label: 'INDICADOR', ...styleColumns },
        { key: 'has_mineras', sortable: true, label: 'EDD <br/> GRUPO MINERAS', ...styleColumns  },
        { key: 'has_conexas', sortable: true, label: 'EDD <br/> GRUPO CONEXAS', ...styleColumns  },
        { key: 'createdAt', sortable: true, label: 'FECHA <br/> REGISTRO', ...styleColumns  },
        { key: 'actions', sortable: false, label: 'OPCIONES', ...styleColumns  }
    ];

    const perPage = ref(10);
    const totalResponsibleAreas = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref('');
    const sortBy = ref('id');
    const isSortDirDesc = ref(true);

    const dataMeta = computed(() => {
        const localItemsCount = refResponsibleAreasListTable.value ? refResponsibleAreasListTable.value.localItems.length : 0;
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalResponsibleAreas.value,
        }
    });

    const refetchData = () => {
        refResponsibleAreasListTable.value.refresh();
    };

    watch([currentPage, perPage, searchQuery], () => {
        refetchData();
    });

    const fetchResponsibleAreas = (ctx, callback) => {
        store
            .dispatch('app-responsible-area/fetchResponsibleAreas', {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value
            })
            .then(response => {
                const { responsibleAreas, total } = response.data;
                callback(responsibleAreas);
                totalResponsibleAreas.value = total;
            })
            .catch(() => {
				toastNotification('Error al obtener lista de áreas responsables', false)
            })
    };

    return {
        fetchResponsibleAreas,
        tableColumns,
        perPage,
        currentPage,
        totalResponsibleAreas,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refResponsibleAreasListTable,

        refetchData
    }
}